
import '@/assets/scss/index.scss'

import _ from 'lodash'
import SwiperWrap from '@/components/ds/common/SwiperCmp.vue'
import spexhbtTabCmp from '@/components/ds/common/spexhbtTabCmp.vue' // 탭
import ExbtProdUnitCmp from '@/components/ds/common/ExbtProdUnitCmp.vue' // 상품유닛
import TotalCount from '~/components/common/sort/TotalCount.vue'
import NoData from '@/components/common/template/NoData.vue'
import { commonfunc } from '~/mixin/common'
import { exbtAsyncData } from '~/scriptData/ds/exbtMixin.js'
import * as exbt from '~/scriptData/ds/exbtCommon.js'
import { homepageTag } from '~/utils/criteo'

export default {
  name: 'ExbtListPage',
  components: {
    TotalCount,
    SwiperWrap,
    spexhbtTabCmp,
    ExbtProdUnitCmp,
    NoData
  },
  mixins: [exbtAsyncData, commonfunc],
  layout: 'DsMainLayout',
  data () {
    return {
      breadcrumbs: [
        {
          url: process.env.WEB_BASE_URL + '/ds/exbt/C103',
          text: '기획전',
        },
      ],
      exbtList: [''],
      swiperOpt: {
        auto: true, // 자동재생
        loop: true, // 무한루프
        navigation: true, // 좌우 버튼
        pagination: false // 페이지 표기
      },
      active: '1',
      select1: '최신순',
      options1: [{
        value: '최신순',
        label: '최신순'
      }, {
        value: '인기순',
        label: '인기순'
      }, {
        value: '마감임박순',
        label: '마감임박순'
      }],
      currentPage: 1,
      contents: [],
      type: {},
      sortNm: '',
      planProdList: [],
      sliceCnt: 7,
      firstInitComplete: false
    }
  },
  jsonld () {
    const items = this.breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.url,
        name: item.text,
      },
    }))
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items,
    }
  },
  head () {
    return {
      title: '기획전 : 다이소몰',
      meta: [
        { hid: 'description', name: 'description', content: '일상이 다이소가 되다. 온라인 국민가게, 다이소' },
        { hid: 'og:title', property: 'og:title', content: '기획전 : 다이소몰' },
        { hid: 'og:url', property: 'og:url', content: window.location.href },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:site_name', property: 'og:site_name', content: '다이소몰' },
        { hid: 'og:description', property: 'og:description', content: '일상이 다이소가 되다. 온라인 국민가게, 다이소' }
      ],
    }
  },
  computed: {
    totalCnt: function () {
      return _.size(this.planProdList)
    },
    swiperData: function () {
      return this.bannerList?.map((e) => {
        return {
          imgUrl: e?.pcomIconAtchFileUrl,
          name: e?.banrRplcTextNm,
          tit: e?.hdcpy,
          txt: e?.subcpy
        }
      })
    },
    plainList: function () {
      return this.exbtList.map((item, idx) => {
        const videoItem = item?.mtrls?.find((item) => {
          return (
            item?.exhMtrlTyCd === '01' && _.head(_.head(item?.exhCmptmtMtrlDtl)?.details)?.mblVideoAtchFileUrl
          )
        })

        let nameItem = ''
        item?.mtrls?.find((item) => {
          if (item?.exhMtrlTyCd === '03' && _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '20')?.textNm) {
            nameItem = _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '20')?.textNm
            return true
          }
          return false
        })

        let descItem = ''
        item?.mtrls?.find((item) => {
          if (item?.exhMtrlTyCd === '03' && _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '30')?.textNm) {
            descItem = _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '30')?.textNm
            return true
          }
          return false
        })

        const thumbItem = item?.mtrls?.find((item) => {
          return (
            item?.exhMtrlTyCd === '01' && _.head(_.head(item?.exhCmptmtMtrlDtl)?.details)?.pcThmnlAtchFileUrl
          )
        })

        const iconItem = item?.mtrls?.find((item) => {
          return (
            item?.exhMtrlTyCd === '01' && _.head(_.head(item?.exhCmptmtMtrlDtl)?.details)?.pcomIconAtchFileUrl
          )
        })

        const eyebrowItem = {
          text: '',
          color: 'black'
        }

        item?.mtrls?.forEach((item) => {
          if (item?.exhMtrlTyCd === '03' && _.head(item?.exhCmptmtMtrlDtl)) {
            const detail = _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '10')

            if (detail) {
              eyebrowItem.text = detail?.textNm
              eyebrowItem.color = detail?.textFontColorCd
            }
          }
        })

        return {
          id: idx,
          exbtNo: item?.exbtNo,
          topFlag: [{
            text: item?.exbtThmeNm,
            bgColor: item?.exbtThmeBgColorCd
          }],
          video: videoItem
            ? _.head(_.head(videoItem?.exhCmptmtMtrlDtl)?.details)?.pcVideoAtchFileUrl
            : null,
          thumb: iconItem
            ? _.head(_.head(iconItem?.exhCmptmtMtrlDtl)?.details)?.pcomIconAtchFileUrl
            : _.head(_.head(thumbItem?.exhCmptmtMtrlDtl)?.details)?.pcThmnlAtchFileUrl,
          eyebrow: eyebrowItem,
          name: nameItem,
          desc: descItem.replace(/\n/ig, '<br>'),
          reviewNum: this.isNotEmpty(item?.inct) ? item?.inct : 0,
          exhStDtm: item?.exhStDtm,
          exhEdDtm: item?.exhEdDtm,
          frRgDtm: item?.frRgDtm
        }
      })
    },
    tabsData: function () {
      let addTabsData = null
      const set = new Set(this.plainList.map((item) => { return item.topFlag[0].text }))
      addTabsData = Array.from(set)
        .map((item, index) => ({ // 데이터 생성
          id: index + 2,
          title: item
        }))
      const defaultTabsData = {
        id: 1,
        title: '전체'
      }
      return Array.concat(defaultTabsData, addTabsData)
    },
  },
  watch: {
  },
  async mounted () {
    await this.setDefaultList()
    this.planProdList = this.plainList
    this.firstInitComplete = true
    this.$nuxt.$emit('page-mounted')

    homepageTag('')
    this.callAirBridgeForProductListView('exbt', '없음')
  },
  activated () {
    if (this.firstInitComplete) {
      this.$nuxt.$emit('page-mounted')
    }
  },
  methods: {
    async setDefaultList () {
      const exbtList = await this.$api.post('/ds/exbt/selExbt', { exbtThmeNm: '', exbtListExprYn: 'Y' })
        .then((res) => {
          if (res.data.success) {
            return res.data.data.filter((item) => { return item.aplMdiaPcomYn === 'Y' })
          }
        })
      this.exbtList = await exbt.getExbtMtrlsList(exbtList, this.$api)
    },
    // 기획전 리스트 필터링 및 정렬 함수
    filteredList (id) {
    // 필터링된 리스트
      if (id === '1') {
        this.planProdList = this.plainList
      } else {
        this.planProdList = this.plainList.filter((item) => {
          return item.topFlag[0].text === this.tabsData[id - 1].title
        })
      }
    },
    sortedList () {
      const filteredList = [...this.planProdList]

      switch (this.sortNm) {
        case '최신순':
          filteredList.sort((a, b) => {
            return new Date(b.frRgDtm) - new Date(a.frRgDtm)
          })
          break
        case '인기순':
          filteredList.sort((a, b) => {
            return b.reviewNum - a.reviewNum
          })
          break
        case '마감임박순':
          filteredList.sort((a, b) => {
            return new Date(a.exhEdDtm) - new Date(b.exhEdDtm)
          })
          break
        default:
          filteredList.sort((a, b) => {
            return new Date(b.frRgDtm) - new Date(a.frRgDtm)
          })
      }

      this.planProdList = filteredList
    },
    tabChanged (id) {
      this.filteredList(id)
    },
    changeSort (val) {
      this.sortNm = val
      this.sortedList()
    },
    callAirBridgeForProductListView (categoryName, categoryNameDetail) {
      const productListInfo = new this.$airbridge.ProductListObject(categoryName, categoryNameDetail)
      this.$airbridge.viewProductList(productListInfo)
    },
  }
}
